import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { Observable, firstValueFrom } from 'rxjs';
import { IconModel } from './models/icon.model';

@Component({
  selector: 'fb-icon',
  template: `
    <div class="fb-icon icon-wrapper">
      <mat-icon class="icon" *ngIf="svgIconName" [svgIcon]="svgIconName"></mat-icon>
      <mat-icon *ngIf="svgIconName === null">{{ fallbackIcon }}</mat-icon>
    </div>
  `,
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input() set iconName(name: string) {
    if (!name) return;
    this.isIconRegistered(name);
  }
  @Input() set iconInNamespace(icon: IconModel) {
    if (icon.namespace) {
      this.isIconRegistered(icon.name, icon.namespace);
    } else {
      this.isIconRegistered(icon.name);
    }
  }
  @Input() fallbackIcon: string = 'error';
  @Input() set width(width: number) {
    this.iconWidth = `${width}px`;
  }
  @HostBinding('style.--icon-width') iconWidth: string = '24px';
  svgIconName?: string;

  constructor(private matIconRegistry: MatIconRegistry, private cdr: ChangeDetectorRef) {}

  private async isIconRegistered(name: string, namespace?: string): Promise<void> {
    if (!name) return;
    const iconRegistry: Observable<SVGElement> = namespace
      ? this.matIconRegistry.getNamedSvgIcon(name, namespace)
      : this.matIconRegistry.getNamedSvgIcon(name);

    await firstValueFrom(iconRegistry)
      .then(() => {
        this.svgIconName = namespace ? `${namespace}:${name}` : name;
        this.cdr.markForCheck();
      })
      .catch(() => {
        this.svgIconName = null;
        this.cdr.markForCheck();
      });
  }
}
